module.exports = __webpack_public_path__ + "0fd80fd379c960086f2d8bc3a2ec26d8.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/windmill.png
// module id = 1943
// module chunks = 0